import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-branch-name',
  templateUrl: './branch-name.component.html',
  styleUrls: ['./branch-name.component.scss']
})
export class BranchNameComponent implements OnInit {

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
  }
  closedialog() {
    this.dialog.closeAll();
  }

}
